<template>
    <div class="products-wrapper" :class="skeletonCount ? 'grid-' + skeletonCount : ''">
        <div class="product-skeleton" v-for="n in skeletonCount" :key="n">
            <div class="skeleton-animation"></div>
            <div class="top">
                <div class="circle"></div>
                <div class="title"></div>
            </div>
            <div class="inner tw-p-5">
                <div class="meta"></div>
                <div class="desc"></div>
                <div class="desc"></div>
                <div class="desc"></div>
                <div class="desc"></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
      name: 'CourseSkeleton',

      props: {
        skeletonCount: {
          required: false,
          default: 8,
        },
      }
    }
</script>

<style lang="scss" scoped>
    @mixin course-skeleton-item($width, $height, $margintop, $marginbottom, $background:"#e8e8e8") {
        background: unquote("$background");
        border-radius: 3px;
        width: $width;
        flex-basis: $width;
        height: $height;
        margin-top: $margintop;
        margin-bottom: $marginbottom;
    }

    .product-skeleton {
        @apply tw-bg-white tw-w-full tw-rounded tw-relative tw-overflow-hidden;
        box-shadow: 0px 8px 4px -3px #e2e5ea;

        .skeleton-animation {
            height: 125%;
            top: -20px;
            width: 30px;
            position: absolute;
            background: #ffffff;
            opacity: 0.5;
            transform: rotate(15deg);
            animation: loading-course-skeleton 1.5s ease infinite;
        }

        @keyframes loading-course-skeleton {
            0% {
                left: -150px;
            }
            50% {
                left: 125%;
            }
            50% {
                left: -150x;
            }
            100% {
                left: 125%;
            }
        }

        .top {
            @apply tw-flex tw-w-full tw-flex-col tw-justify-center tw-items-center;
            background: #afafaf;
            padding-bottom: 22px;

            .circle {
                border-radius: 100%;
                background: #cccccc;
                height: 100px;
                width: 100px;
                margin-top: 27px;
                margin-bottom: 20px;
            }

            .title {
                background: #777777;
                border-radius: 3px;
                width: 145px;
                flex-basis: 30px;
                height: 30px;
                margin-top: 0px;
                margin-bottom: 0px;
            }
        }

        .inner {
            .meta {
                @include course-skeleton-item(80%, 20px, 0px, 15px, #f5f5f5);
            }

            .desc {
                @include course-skeleton-item(100%, 25px, 0px, 7px);

                &:last-of-type {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>